export default __webpack_public_path__ + "static/media/pdf-icon.eca42048.png";